import { render, staticRenderFns } from "./fitting-product.vue?vue&type=template&id=5d9549c3&scoped=true&"
import script from "./fitting-product.vue?vue&type=script&lang=js&"
export * from "./fitting-product.vue?vue&type=script&lang=js&"
import style0 from "./fitting-product.vue?vue&type=style&index=0&id=5d9549c3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9549c3",
  null
  
)

export default component.exports